import { Component, ContentChild, EventEmitter, input, Output } from '@angular/core';
import { ListItemDirective } from './list-item.directive';

@Component({
  standalone: false,
  selector: 'wr-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
})
export class ListViewComponent<Item> {

  canCreate = input<boolean>(true);
  items = input<Item[] | null | undefined>();
  loading = input<boolean>(false);
  selected = input<Item | null | undefined>();
  searchText = input<string | undefined>();
  showSearch = input<boolean>(true);

  @ContentChild(ListItemDirective)
  listItemTemplate?: ListItemDirective;

  @Output()
  selectedChange = new EventEmitter<Item>();
  @Output()
  searchTextChange = new EventEmitter<string>();
  @Output()
  addItemClicked = new EventEmitter<void>();
  @Output()
  scrolledToEnd = new EventEmitter<void>();
}
